import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=515b7c7e"
import script from "./Crumb.vue?vue&type=script&lang=js"
export * from "./Crumb.vue?vue&type=script&lang=js"
import style0 from "./Crumb.vue?vue&type=style&index=0&id=515b7c7e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports